<template>
  <div class="card-info">
    <div>
      <card-header></card-header>
      <tabs :tabs="tabs" :active="activeTab" @setTab="setTab" />
      <info v-if="activeTab === 0 && id" :id="id" />
    </div>
  </div>
</template>
<script>
import CardHeader from "./CardHeader";

import Info from "./Group/Info";
import Tabs from "../Tabs";
import { errorNotify } from "../../plugins/functions";

export default {
  name: "order",
  props: ["id"],
  components: {
    CardHeader,
    Tabs,
    Info,
  },
  data() {
    return {
      loading: true,
      tabs: [
        {
          title: "Информация",
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    },
  },
  created() {},
};
</script>